/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import { SleepApneaValuesFragmentDoc } from './SleepApneaProfile';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateSleepApneaProfileMutationVariables = SchemaTypes.Exact<{
  input: SchemaTypes.UpdateSleepApneaInput;
}>;


export type UpdateSleepApneaProfileMutation = { __typename?: 'Mutation', updateSleepApnea: { __typename?: 'UpdateSleepApneaPayload', nextStepPath: string | null, form: { __typename?: 'SleepApnea', id: string, apneaHypopneaIndex: number | null, apneaIndex: number | null, diagnosedAt: string | null, everTreated: boolean | null, oxygenSaturation: number | null, respiratoryDisturbanceIndex: number | null, severity: string | null, sleepStudyConducted: boolean | null, sleepStudyConductedAt: string | null, treatedAt: string | null, usesCPAPMachine: boolean | null } } | null };


export const UpdateSleepApneaProfileDocument = gql`
    mutation UpdateSleepApneaProfile($input: UpdateSleepApneaInput!) {
  updateSleepApnea(input: $input) {
    form {
      id
      ...SleepApneaValues
    }
    nextStepPath
  }
}
    ${SleepApneaValuesFragmentDoc}`;
export type UpdateSleepApneaProfileMutationFn = Apollo.MutationFunction<UpdateSleepApneaProfileMutation, UpdateSleepApneaProfileMutationVariables>;
export function useUpdateSleepApneaProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSleepApneaProfileMutation, UpdateSleepApneaProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSleepApneaProfileMutation, UpdateSleepApneaProfileMutationVariables>(UpdateSleepApneaProfileDocument, options);
      }
export type UpdateSleepApneaProfileMutationHookResult = ReturnType<typeof useUpdateSleepApneaProfileMutation>;
export type UpdateSleepApneaProfileMutationResult = Apollo.MutationResult<UpdateSleepApneaProfileMutation>;
export type UpdateSleepApneaProfileMutationOptions = Apollo.BaseMutationOptions<UpdateSleepApneaProfileMutation, UpdateSleepApneaProfileMutationVariables>;